import { FileNode } from '../../../src/types';

/**
 * Find a node in the file tree by its path
 * @param fileTree The file tree to search
 * @param path The path to search for
 * @returns The node if found, null otherwise
 */
export function findNodeByPath(fileTree: FileNode, path: string): FileNode | null {
  // Handle root path
  if (path === '/' || path === '') {
    return fileTree;
  }

  // Normalize path
  const normalizedPath = normalizePath(path);
  
  // Split path into segments
  const segments = normalizedPath.split('/').filter(Boolean);
  
  // Start from the root node
  let currentNode: FileNode | null = fileTree;
  
  // Traverse the tree
  for (const segment of segments) {
    if (!currentNode || !currentNode.children) {
      return null;
    }
    
    // Find the child node with matching name
    const childNode: FileNode | undefined = currentNode.children.find(
      child => child.name.toLowerCase() === segment.toLowerCase()
    );
    
    if (!childNode) {
      return null;
    }
    
    currentNode = childNode;
  }
  
  return currentNode;
}

/**
 * Normalize a path by removing .md extension and ensuring it starts with /
 * @param path The path to normalize
 * @returns The normalized path
 */
export function normalizePath(path: string): string {
  // Ensure path starts with /
  let normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // Remove .md extension if present
  if (normalizedPath.endsWith('.md')) {
    normalizedPath = normalizedPath.slice(0, -3);
  }
  
  return normalizedPath;
}

/**
 * Handle direct navigation to a markdown file URL
 * @param path The current URL path
 * @returns The normalized path
 */
export function handleDirectNavigation(path: string): string {
  // Get path from URL
  const urlPath = path || window.location.pathname;
  
  // Normalize the path
  return normalizePath(urlPath);
}
